var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-breadcrumb',{staticClass:"bread_crumbs"},_vm._l((_vm.status),function(item,index){return _c('b-breadcrumb-item',{key:index,class:{
      completed: !_vm.typeOfColorIsObject && _vm.project.statusProject - 1 > index,
      active: _vm.project.statusProject - 1 === index
    },style:({
      '--breadcrumb-color':
        _vm.project.statusProject - 1 === index ? _vm.breadcrumbColor : ''
    }),attrs:{"href":("/projects/" + (_vm.project.id) + "/orders/estimates")}},[_vm._v(_vm._s(_vm.project.statusProject - 1 === index && _vm.breadStatusName
        ? _vm.breadStatusName
        : item.text))])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }